<div data-test="u4JjbOa7" *ngIf="showLoader()" [class]="classPrefix + context">
  <td
    data-test="OhuK7grV"
    *ngIf="context === LoaderContext.Table; else restContext"
    [attr.colspan]="colspan"
    class="loader"
  >
    <ng-container *ngTemplateOutlet="loader"></ng-container>
  </td>

  <ng-template #restContext>
    <div data-test="mc3nOIRF" class="loader">
      <ng-container *ngTemplateOutlet="loader"></ng-container>
    </div>
  </ng-template>

  <ng-template #loader>
    <svg
      data-test="CJ9UuhEx"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      class="lds-gooeyring"
      width="200px"
      height="200px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      style="background: none"
    >
      <defs>
        <filter
          id="gooey"
          x="-100%"
          y="-100%"
          width="300%"
          height="300%"
          color-interpolation-filters="sRGB"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="1.2000000000000002" />
          <feComponentTransfer result="cutoff">
            <feFuncA type="linear" slope="10" intercept="-5" />
          </feComponentTransfer>
        </filter>
      </defs>
      <g filter="url(#gooey)">
        <g transform="translate(50 50)">
          <g transform="rotate(194.353)">
            <circle cx="16" cy="0" r="4.00862" fill="#1d3f72">
              <animate
                attributeName="r"
                keyTimes="0;0.5;1"
                values="1.7999999999999998;4.199999999999999;1.7999999999999998"
                dur="3s"
                repeatCount="indefinite"
                begin="-3s"
              />
            </circle>
            <animateTransform
              attributeName="transform"
              type="rotate"
              keyTimes="0;1"
              values="0;360"
              dur="3s"
              repeatCount="indefinite"
              begin="0s"
            />
          </g>
        </g>
        <g transform="translate(50 50)">
          <g transform="rotate(208.707)">
            <circle cx="16" cy="0" r="3.81724" fill="#5699d2">
              <animate
                attributeName="r"
                keyTimes="0;0.5;1"
                values="1.7999999999999998;4.199999999999999;1.7999999999999998"
                dur="1.5s"
                repeatCount="indefinite"
                begin="-2.25s"
              />
            </circle>
            <animateTransform
              attributeName="transform"
              type="rotate"
              keyTimes="0;1"
              values="0;360"
              dur="1.5s"
              repeatCount="indefinite"
              begin="-0.75s"
            />
          </g>
        </g>
        <g transform="translate(50 50)">
          <g transform="rotate(43.0603)">
            <circle cx="16" cy="0" r="2.37414" fill="#d8ebf9">
              <animate
                attributeName="r"
                keyTimes="0;0.5;1"
                values="1.7999999999999998;4.199999999999999;1.7999999999999998"
                dur="1s"
                repeatCount="indefinite"
                begin="-1.5s"
              />
            </circle>
            <animateTransform
              attributeName="transform"
              type="rotate"
              keyTimes="0;1"
              values="0;360"
              dur="1s"
              repeatCount="indefinite"
              begin="-1.5s"
            />
          </g>
        </g>
        <g transform="translate(50 50)">
          <g transform="rotate(57.4138)">
            <circle cx="16" cy="0" r="2.56552" fill="#71c2cc">
              <animate
                attributeName="r"
                keyTimes="0;0.5;1"
                values="1.7999999999999998;4.199999999999999;1.7999999999999998"
                dur="0.75s"
                repeatCount="indefinite"
                begin="-0.75s"
              />
            </circle>
            <animateTransform
              attributeName="transform"
              type="rotate"
              keyTimes="0;1"
              values="0;360"
              dur="0.75s"
              repeatCount="indefinite"
              begin="-2.25s"
            />
          </g>
        </g>
      </g>
    </svg>
  </ng-template>
</div>
